<template>
  <van-nav-bar
    title="修改密码"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    fixed
    placeholder
  ></van-nav-bar>

  <div class="resetpwd">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="phone_no"
          label="账号"
          readonly
          placeholder="请输入帐号"
          maxlength="20"
          class="account-field"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="old_pwd"
          label="旧密码"
          type="password"
          placeholder="请输入旧密码"
          clearable
          maxlength="18"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="new_pwd"
          label="新密码"
          type="password"
          placeholder="请输入6-18位新密码"
          clearable
          maxlength="18"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="confirm_pwd"
          label="确认新密码"
          type="password"
          placeholder="请再次输入新密码"
          clearable
          maxlength="18"
          :rules="[{ required: true }]"
        />
      </van-cell-group>
      <div style="margin: 60px 18px">
        <van-button round block type="primary" native-type="submit">
          修改密码
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { Toast, Dialog } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";
import { encryption } from "../common/js/utils";
import { clearLoginState } from "../utils/auth";
import { getSavedAccounts, saveAccount } from "../utils/accountStore";

export default {
  setup() {
    let phone_no = ref("");
    let old_pwd = ref("");
    let new_pwd = ref("");
    let confirm_pwd = ref("");
    const router = useRouter();

    const onClickLeft = () => {
      router.go(-1);
    };

    onMounted(() => {
      // 优先取本次登录账号（sessionStorage，不依赖"记住密码"）；localStorage 仅作历史兜底
      phone_no.value = sessionStorage.getItem("userNo") || localStorage.getItem("userNo") || "";
    });

    function isPwd(pwd) {
      var regPwd = /^[a-zA-Z0-9~!@#$%^&*?]{6,18}$/;
      if (regPwd.test(pwd)) {
        return true;
      } else {
        return false;
      }
    }

    const onSubmit = () => {
      if (!isPwd(old_pwd.value)) {
        Toast("旧密码格式不正确");
        return;
      }
      if (!isPwd(new_pwd.value)) {
        Toast("新密码格式为6-18位数字字母或其组合");
        return;
      }
      if (new_pwd.value !== confirm_pwd.value) {
        Toast("两次输入的新密码不一致");
        return;
      }
      if (old_pwd.value === new_pwd.value) {
        Toast("新密码不能与旧密码相同");
        return;
      }

      // 弹出确认对话框
      Dialog.confirm({
        title: "确认修改",
        message: "密码修改成功后需重新登录，是否确认修改？",
      })
        .then(() => {
          // 用户点击确认
          Toast.loading({ message: "提交中...", forbidClick: true });

          api
            .resetPwd({
              user_no: phone_no.value,
              oldPassword: old_pwd.value,
              newPassword: new_pwd.value,
            })
            .then((res) => {
              Toast.clear();
              if (res.data.code == 1001) {
                Toast.success("密码修改成功");
                // 改密码只影响当前这一个账号：列表里其它账号的密码没变，不该跟着一起清掉。
                // 已保存过的当前账号顺手把密码更新成新的，之后仍能直接切换。
                const saved = getSavedAccounts().find((a) => a.userNo === phone_no.value);
                if (saved) {
                  saveAccount({ ...saved, pwd: encryption(new_pwd.value) });
                }
                // 只清登录态（sid/userNo/pwd 已失效），保留 savedAccounts 与 openId
                clearLoginState();
                router.replace("/");
              } else {
                Toast(res.data.message || "修改失败");
              }
            })
            .catch((err) => {
              Toast(err.message || "网络异常");
            });
        })
        .catch(() => {
          // 用户点击取消
        });
    };
    return {
      phone_no,
      old_pwd,
      new_pwd,
      confirm_pwd,
      onSubmit,
      onClickLeft,
    };
  },
};
</script>

<style scoped>
.account-field :deep(.van-field__control) {
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  word-break: break-all;
}
</style>
